/* Foberry FAQ book. Turns accordion groups (home FAQ, PDP FAQ, fb-faq section) into a book on tablet/desktop; phones keep the normal dropdown.
   The original markup stays in the page so SEO / structured data is untouched. Works in the theme editor (rebuilds on section load, opens the selected question). */
(function () {
  var d = document, W = window;
  var SCOPES = '[id*="section_jpxqz6"], [id*="section_Cg8cfn"], .fbq, [data-fb-book]';
  var reduce = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function esc(s) { var p = d.createElement('p'); p.textContent = s; return p.innerHTML; }

  function collect(scope) {
    var groups = [], seen = [];
    var accs = scope.querySelectorAll('accordion-custom');
    for (var i = 0; i < accs.length; i++) {
      var par = accs[i].parentNode;
      if (seen.indexOf(par) > -1) continue;
      seen.push(par);
      var items = [];
      for (var k = 0; k < par.children.length; k++) {
        var a = par.children[k];
        if (a.tagName.toLowerCase() !== 'accordion-custom') continue;
        var sum = a.querySelector('summary'), body = a.querySelector('.details-content');
        if (!sum || !body) continue;
        var hd = sum.querySelector('.details__header, .accordion__title') || sum;
        items.push({ src: a, q: hd.textContent.replace(/\s+/g, ' ').trim(), a: body.innerHTML });
      }
      if (items.length > 1) groups.push({ first: items[0].src, items: items, hide: items.map(function (x) { return x.src; }) });
    }
    var lists = scope.querySelectorAll('.fbq__list');
    for (var j = 0; j < lists.length; j++) {
      var its = [].map.call(lists[j].querySelectorAll('.fbq__item'), function (e) {
        var s = e.querySelector('summary span'), b = e.querySelector('.fbq__a');
        return { src: e, q: s ? s.textContent.trim() : '', a: b ? b.innerHTML : '' };
      });
      if (its.length > 1) groups.push({ first: lists[j], items: its, hide: [lists[j]] });
    }
    return groups;
  }

  function build(g) {
    var items = g.items, cur = -1, busy = null;
    var root = d.createElement('div');
    root.className = 'fbb';
    var toc = items.map(function (it, n) {
      return '<li><button type="button" class="fbb__q" data-i="' + n + '"><span class="fbb__n">' + pad(n + 1) + '</span><span class="fbb__t">' + esc(it.q) + '</span><span class="fbb__dots"></span><span class="fbb__p">' + (n + 1) + '</span></button></li>';
    }).join('');
    root.innerHTML = '<div class="fbb__book"><div class="fbb__page fbb__page--toc"><p class="fbb__eyebrow">Contents</p><ol class="fbb__list">' + toc + '</ol></div>' +
      '<div class="fbb__page fbb__page--ans"><div class="fbb__stack"><div class="fbb__sheet" data-under></div><div class="fbb__leaf" aria-hidden="true"></div></div></div></div>';
    g.first.parentNode.insertBefore(root, g.first);
    g.hide.forEach(function (e) { e.classList.add('fbb-src-hidden'); });

    var under = root.querySelector('[data-under]'), leaf = root.querySelector('.fbb__leaf');
    var btns = root.querySelectorAll('.fbb__q');

    function html(n) {
      var it = items[n];
      return '<p class="fbb__no">Question ' + pad(n + 1) + ' / ' + pad(items.length) + '</p><h3 class="fbb__h">' + esc(it.q) + '</h3><div class="fbb__a">' + it.a + '</div><p class="fbb__pg">— ' + (n + 1) + ' —</p>';
    }
    function mark(n) { for (var k = 0; k < btns.length; k++) btns[k].setAttribute('aria-current', k === n ? 'true' : 'false'); }
    function show(n, instant) {
      if (n === cur) return;
      var old = cur;
      cur = n; mark(n);
      if (old < 0 || instant || reduce) { under.innerHTML = html(n); return; }
      leaf.classList.remove('is-turn'); void leaf.offsetWidth;
      leaf.innerHTML = '<div class="fbb__sheet">' + html(old) + '</div>';
      under.innerHTML = html(n);
      leaf.classList.add('is-turn');
      clearTimeout(busy);
      busy = setTimeout(function () { leaf.classList.remove('is-turn'); leaf.innerHTML = ''; }, 560);
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.fbb__q') : null;
      if (b) show(+b.getAttribute('data-i'));
    });
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var n = cur + (e.key === 'ArrowDown' ? 1 : -1);
      if (n < 0 || n >= items.length) return;
      e.preventDefault(); show(n); btns[n].focus();
    });
    show(0, true);
    root.__fbbShow = function (src) {
      for (var n = 0; n < items.length; n++) if (items[n].src === src || items[n].src.contains(src) || src.contains(items[n].src)) { show(n); return true; }
      return false;
    };
    return root;
  }

  function init(root) {
    var base = root || d;
    var list = base.querySelectorAll ? [].slice.call(base.querySelectorAll(SCOPES)) : [];
    if (root && root.matches && root.matches(SCOPES)) list.push(root);
    list.forEach(function (sc) {
      if (sc.__fbb) return;
      var gs = collect(sc);
      if (!gs.length) return;
      sc.__fbb = 1;
      gs.forEach(build);
    });
  }
  function ready(f) { d.readyState === 'loading' ? d.addEventListener('DOMContentLoaded', f) : f(); }
  ready(function () { init(); });
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
  d.addEventListener('shopify:block:select', function (e) {
    var sc = e.target.closest ? e.target.closest(SCOPES) : null;
    if (!sc) return;
    [].forEach.call(sc.querySelectorAll('.fbb'), function (b) { b.__fbbShow && b.__fbbShow(e.target); });
  });
})();